import React, { useState } from 'react';
import SalesLayout from '../components/sales/SalesLayout';
import InvoicesModule from '../components/sales/InvoicesModule';
import EstimatesModule from '../components/sales/EstimatesModule';
import SalesClientsModule from '../components/sales/SalesClientsModule';
import SalesReportsModule from '../components/sales/SalesReportsModule';
import SalesNotificationsModule from '../components/sales/SalesNotificationsModule';
import InvoiceEditor from './InvoiceEditor';
import InvoiceView from './InvoiceView';
import EstimateEditor from './EstimateEditor';
import EstimateView from './EstimateView';
import { CRMModule, SalesSettingsModule } from './SalesGear';

const SalesGearPage = ({ currentUser, onBackToGears }) => {
  const [salesPage, setSalesPage] = useState('home');
  const [selectedEstimate, setSelectedEstimate] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const resolvedSalesPage = salesPage === 'home' ? 'estimates' : salesPage;
  const activeSalesTab = ['edit-estimate', 'create-estimate', 'view-estimate'].includes(resolvedSalesPage)
    ? 'estimates'
    : ['edit-invoice', 'create-invoice', 'view-invoice'].includes(resolvedSalesPage)
      ? 'invoices'
      : resolvedSalesPage;

  let salesContent = null;
  if (resolvedSalesPage === 'estimates') {
    salesContent = (
      <EstimatesModule
        onBack={() => setSalesPage('estimates')}
        onEdit={(estimate) => {
          setSelectedEstimate(estimate);
          setSalesPage('view-estimate');
        }}
        onCreate={() => {
          setSelectedEstimate(null);
          setSalesPage('edit-estimate');
        }}
        onCreateInvoice={(invoice) => {
          setSelectedInvoice(invoice);
          setSalesPage('edit-invoice');
        }}
        onOpenNotifications={() => setSalesPage('notifications')}
      />
    );
  }

  if (resolvedSalesPage === 'view-estimate') {
    salesContent = (
      <EstimateView
        estimate={selectedEstimate}
        onBack={() => setSalesPage('estimates')}
        onEdit={() => setSalesPage('edit-estimate')}
        onCreateInvoice={(invoice) => {
          setSelectedInvoice(invoice);
          setSalesPage('edit-invoice');
        }}
        currentUser={currentUser}
      />
    );
  }

  if (resolvedSalesPage === 'edit-estimate') {
    salesContent = (
      <EstimateEditor
        estimate={selectedEstimate}
        onBack={() => setSalesPage(selectedEstimate ? 'view-estimate' : 'estimates')}
        onSave={() => setSalesPage(selectedEstimate ? 'view-estimate' : 'estimates')}
        onCreateInvoice={(invoice) => {
          setSelectedInvoice(invoice);
          setSalesPage('edit-invoice');
        }}
        onDuplicate={(duplicate) => {
          setSelectedEstimate(duplicate);
          setSalesPage('edit-estimate');
        }}
      />
    );
  }

  if (resolvedSalesPage === 'invoices') {
    salesContent = (
      <InvoicesModule
        onBack={() => setSalesPage('invoices')}
        onEdit={(invoice) => {
          setSelectedInvoice(invoice);
          setSalesPage('view-invoice');
        }}
        onCreate={() => {
          setSelectedInvoice(null);
          setSalesPage('edit-invoice');
        }}
      />
    );
  }

  if (resolvedSalesPage === 'view-invoice') {
    salesContent = (
      <InvoiceView
        invoice={selectedInvoice}
        onBack={() => setSalesPage('invoices')}
        onEdit={() => setSalesPage('edit-invoice')}
        currentUser={currentUser}
      />
    );
  }

  if (resolvedSalesPage === 'edit-invoice') {
    salesContent = (
      <InvoiceEditor
        invoice={selectedInvoice}
        onBack={() => setSalesPage(selectedInvoice ? 'view-invoice' : 'invoices')}
        onSave={() => setSalesPage(selectedInvoice ? 'view-invoice' : 'invoices')}
        onRefresh={(updated) => {
          setSelectedInvoice(updated);
        }}
        currentUser={currentUser}
        onDuplicate={(duplicate) => {
          setSelectedInvoice(duplicate);
          setSalesPage('edit-invoice');
        }}
      />
    );
  }

  if (resolvedSalesPage === 'clients') {
    salesContent = <SalesClientsModule onBack={() => setSalesPage('clients')} />;
  }

  if (resolvedSalesPage === 'reports') {
    salesContent = <SalesReportsModule onBack={() => setSalesPage('reports')} />;
  }

  if (resolvedSalesPage === 'notifications') {
    salesContent = <SalesNotificationsModule />;
  }

  if (resolvedSalesPage === 'crm') {
    salesContent = <CRMModule onBack={() => setSalesPage('crm')} currentUser={currentUser} />;
  }

  if (resolvedSalesPage === 'settings') {
    salesContent = <SalesSettingsModule onBack={() => setSalesPage('settings')} />;
  }

  return (
    <SalesLayout
      activeTab={activeSalesTab}
      onNavigate={setSalesPage}
      onBackToGears={onBackToGears}
      currentUser={currentUser}
    >
      {salesContent}
    </SalesLayout>
  );
};

export default SalesGearPage;
